import "../.././styles/Constitution.css";

function ArticleEight() {
    return(
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE VIII: BORROWING POWERS</h3>
                    <h5>8.1 Borrowing Powers</h5>
                    <p>
                        For the purpose of carrying out the objects of the corporation, the Governing Board may:
                    </p>
                    <ol type="a">
                        <li><p>
                            Borrow and use the property or assets of the corporation as security for borrowing;
                        </p></li>
                        <li><p>
                            Mortgage or otherwise secure any real or personal property of the corporation; and
                        </p></li>
                        <li><p>
                            Whenever necessary, issue a debenture or similar debt instrument or certificate of
                            indebtedness to borrow money at fixed rates in sustaining capital projects.
                        </p></li>
                    </ol>
                </div>
            </div>
    );
}

export default ArticleEight;